import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import { getBatteryTableColumns } from "./columns";

const DEFAULT_PAGE_SIZE = 10; // match the Thermostats table's visible row count
const PREFETCH_PAGES_BEFORE_END = 1;

const BatteriesTable = ({
  memberID,
  devices,
  fetchedCount,
  isLoading,
  isFetchingMore,
  hasNext,
  doFetchBatteryDevices,
  doFetchMoreBatteryDevices,
  onOpenCommandHistory,
}) => {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const columns = useMemo(() => getBatteryTableColumns(onOpenCommandHistory), [onOpenCommandHistory]);

  useEffect(() => {
    doFetchBatteryDevices(memberID);
  }, [memberID]);

  useEffect(() => {
    if (!fetchedCount) return;
    const localPages = Math.ceil(fetchedCount / pageSize);
    if (hasNext && pageIndex >= localPages - PREFETCH_PAGES_BEFORE_END) {
      doFetchMoreBatteryDevices(memberID);
    }
  }, [pageIndex, pageSize, fetchedCount, memberID]);

  const handlePageChange = (index) => {
    setPageIndex(index);
  };

  const handlePageSizeChange = (size, newPage) => {
    setPageSize(size);
    setPageIndex(newPage);
  };

  return (
    <div>
      <ReactTable
        data={devices || []}
        loading={isLoading}
        columns={columns}
        className="-striped -highlight"
        defaultPageSize={DEFAULT_PAGE_SIZE}
        filterable
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
      {isFetchingMore && (
        <div style={{ textAlign: "center", padding: "6px 0", fontSize: "12px", color: "#888" }}>
          Loading more devices…
        </div>
      )}
    </div>
  );
};

BatteriesTable.propTypes = {
  memberID: PropTypes.any,
  devices: PropTypes.array,
  fetchedCount: PropTypes.number,
  isLoading: PropTypes.bool,
  isFetchingMore: PropTypes.bool,
  hasNext: PropTypes.bool,
  doFetchBatteryDevices: PropTypes.func.isRequired,
  doFetchMoreBatteryDevices: PropTypes.func.isRequired,
  onOpenCommandHistory: PropTypes.func.isRequired,
};

export default BatteriesTable;
